const validatePhone = (phone) => {
    return String(phone)
        .toLowerCase()
        .match(
        /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
        );
};

export default validatePhone;